import api from "utils/api";

// Get all FAQs
export const getAllFaQs = async (params = {}) => {
  try {
    const response = await api.get("/faqs", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get single FAQ by ID
export const getFaQById = async (id) => {
  try {
    const response = await api.get(`/faqs/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Create FAQ
export const createFaQ = async (faqData) => {
  try {
    const response = await api.post("/faqs", faqData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Update FAQ
export const updateFaQ = async (id, faqData) => {
  try {
    const response = await api.put(`/faqs/${id}`, faqData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Delete FAQ
export const deleteFaQ = async (id) => {
  try {
    const response = await api.delete(`/faqs/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
